export const base_url = "https://api.qentrainsolutions.com/api/"; 
